export function capitalizeWords(string) {
  if (string === undefined || string === null) {
    return '';
  }
  const text = string.replace(/[^a-zA-Z ]/g, ' ');
  return text.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}
